import { Components, Theme } from '../../material';

export const MuiStepper: Components['MuiStepper'] = {
  styleOverrides: {},
};

export const MuiStepLabel: Components['MuiStepLabel'] = {
  styleOverrides: {
    iconContainer: {},
  },
};

export const MuiStepIcon: Components<Theme>['MuiStepIcon'] = {
  styleOverrides: {
    // nice!
    // this let's us specify sizes in px but the result will be in rem and variable
    // based on theme.typography.htmlFontSize
    root: ({ theme }) => ({
      fontSize: theme.typography.pxToRem(40),
      '&.Mui-completed': {
        color: theme.palette.success.main,
      },
    }),
  },
};

export const MuiStepConnector: Components['MuiStepConnector'] = {
  styleOverrides: {
    root: {
      top: '20px',
      left: 'calc(-50% + 30px)',
      right: 'calc(50% + 30px)',
    },
  },
};
